<template>
    <div>
        <Nav isActive="live"/>
        <div class="pageWD clearfix topm">
            <!-- <BreadCrumb/> -->
            <div class="playerWrap fl">
                
                <video-player 
                    class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    name="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions"
                    @play="onPlayerPlay($event)"
                    @pause="onPlayerPause($event)"
                    @ended="onPlayerEnded($event)"
                    @statechanged="playerStateChanged($event)"
                    @timeupdate="onPlayerTimeupdate($event)"
                    @ready="playerReadied($event)"
                    id="video"
                    style="z-index=0"
                    v-if="isNotstart"
                >
                </video-player>
                <div class="notStart" v-else><img :src="videoPoster" alt=""></div>
                <div class="stage" style="z-index=1000">
                    <vue-baberrage
                        ref="baberrage"
                        :lanesCount="5"
                        :boxHeight= "stageHeight"
                        :isShow= "barrageIsShow"
                        :barrageList = "barrageList"
                        :loop = "barrageLoop"
                        :maxWordCount = "60"
                        :hoverLanePause = "hoverLanePause"
                        :throttleGap="500"
                        v-if="isNotstart"
                        >
                        <!-- <template v-slot:default="slotProps">
                        <span style="color: #000; padding: 15px;">
                            {{slotProps.item.msg}}
                        </span>
                        </template> -->
                    </vue-baberrage>
                </div>
                
            </div>
            <div class="discussWrap fr">
                <div class="discussTab">
                    <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                        <el-tab-pane label='评论' name="pinglun">
                            <div class="discussText">
                                <ul class="discussList" ref='discussList'>
                                    <li class="discussItem" v-for='item in discussList' :key=item.id>
                                        <!-- <span v-if='item.isAssistant'>助教</span> -->
                                        <em>{{item.name}}:</em>
                                        <strong>{{item.content}}</strong>
                                    </li>
                                </ul>
                            </div>
                            <div class="discussBox">
                                <input type="text" v-model="msg" :disabled="disabled" maxlength="30" placeholder="发一条积极的评论"/>
                                <button type="button" @click="addToList" :disabled="disabled">发送</button>
                                <!-- <button type="button" @click="pauseBaberrage">Pause</button> -->
                            </div>
                        </el-tab-pane>
                        <el-tab-pane :label="totalNumber" name="guankan">
                            <div class="headerImgWrap">
                                <el-tabs v-model="activePeople" @tab-click="watchPeople" stretch>
                                    <el-tab-pane :label="isParticipate[0].participate" name="watched">
                                        <ul class="headImgList" >
                                            <li class="headImgItem" :title="item.username" v-for="item in onlineNumber" :key='item.memberId'>
                                                <img :src="item.headimg" alt="">
                                                <span>{{item.username}}</span>
                                            </li>
                                            
                                        </ul>
                                    </el-tab-pane>
                                    <el-tab-pane :label="isParticipate[1].participate" name="nowatch">
                                        <ul class="headImgList">
                                            <li class="headImgItem" :title="item.username" v-for='item in offlineNumber' :key='item.memberId'>
                                                <img :src="item.headimg" alt="">
                                                <span>{{item.username}}</span>
                                            </li>
                                        </ul>
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                
            </div>
            <div class="videoContent clearfix">
                <div class="videoBox fl">
                    <div class="videoInfo fl">
                        <div class="videoImg fl">
                            <img :src="videoPoster" alt="">
                        </div>
                        <div class="videoTeacher fl">
                            <h3>{{videoName}}</h3>
                            <h2><span>主讲老师：{{speakerName}}</span>{{$conFun.parseData(videoTime)}}</h2>
                        </div>
                        <div v-if="isNotstart" :class="barrageIsShow==true?'danmuImg':'closeStyle'" @click="closeDanmu">弹幕</div>
                    </div>
                    <div class="videoIntroduce fl">
                        <div class="videoDetail">课程介绍</div>
                        <div class="videoTextImg" ref="classInfo" v-html="videoDescribe"></div>
                    </div>
                </div>
                
                <div class="otherVideo fr">
                    <h3>其他课程</h3>
                    <ul class="otherVideosList" :class="exceedHeight==true?'mHeight':''">
                        <li 
                            class="otherVideoItem" 
                            @mouseover="mouseOver(index)" 
                            @mouseleave="mouseLeave(index)" 
                            v-for='(items,index) in otherVideoData' 
                            :key='items.liId' 
                            @click="toDetail(items.liId,items.liState,items.type)"
                        >
                            <div class="postImg">
                                <div class="playBack" v-show='isPlayBack == items.liId ? true : false'>
                                    <div class="videoMask"></div>
                                    <div class="playBackText">
                                        <em v-if="items.liState == 2" class="iconfont icon-a-6_huifang playBackIcon w-color" ></em>
                                        <em v-else class="iconfont icon-a-11_zhibozhong playBackIcon w-color"></em>
                                        <!-- <img src="../../assets/images/huifang.png" alt="" class="playBackIcon"> -->
                                        <span>{{items.liState == 2 ? "观看回放" : items.liState == 1 ? "观看直播" : items.liState == 0 ? "即将开始" : ""}}</span>
                                    </div>
                                </div>
                                <img :src='items.liLogo' alt="" class="pImg">
                            </div>
                            <p class="otherVideoTitle" :class="mouseOverActive == items.liId ? 'mouseOverClass':''">{{items.liName}}</p>
                        </li>
                    </ul>
                </div>
            </div>
            
        </div>
        <AudioTip :isTip="isTip" @hideMe="tip"/>
    </div>
    
    
</template>

<script>
    import Cookies from "js-cookie";
    import { MESSAGE_TYPE } from 'vue-baberrage'
    import { getLiveDetail,getLiveDanmus,saveCourseComments,getLiveStateList,getLives,addWatchClassH,recordinout } from '@/api/api'
    import Nav from '../../components/Nav'
    import AudioTip from '../../components/AudioTip.vue';
    // import BreadCrumb from '../../components/BreadCrumb.vue'
    export default {
        name:'Live',
        components:{Nav,AudioTip},
        data(){
            return{
                isTesk:2,  //是否是任务进入，默认为2直接进入，任务进入传1
                taskId:"",
                taskti_ID:"",
                singleWords:false, //是否单人被禁言了
                allWords:false,    //是否全员被禁言了
                disabled:false,    //是否可以发言
                isNotstart:false,
                inOut:1,
                timeNumber:0,
                timer:null,
                isload:false,
                oldv:0,
                isTip:false,
                websock: null, //建立的连接
                lockReconnect: false, //是否真正建立连接
                timeout: 20 * 1000, //20秒一次心跳
                timeoutObj: null, //心跳心跳倒计时
                serverTimeoutObj: null, //心跳倒计时
                timeoutnum: null, //断开 重连倒计时
                wsData:{},
                memberId:Cookies.get('qslmemberId'),
                coid:Cookies.get('qslCOID'),
                activeName: 'pinglun', //页面一加载固定在评论标签
                activePeople:'watched', //标签切换到观看人，固定在已观看
                mouseOverActive:'',  //鼠标移入改变样式
                isPlayBack:false,
                videoPoster:'', //课程封面
                videoName:"", //课程名字
                speakerName:'', //主讲老师
                videoTime:'', //播出时间
                videoDescribe:'', //直播描述
                onlineNumber:null,  //在线人数
                offlineNumber:null, //离线人数
                totalNumber:"",  //总人数
                exceedHeight:false, //课程介绍的高是否超过544px
                isParticipate:[{participate:"已观看"},{participate:"未观看"}],
                liId:"",  //课程ID
                danmuData:{}, //弹幕数据重新整理
                discussData:{}, //评论列表数据重新整理
                myName:Cookies.get('qslmemberName'),
                myHeadImg:Cookies.get('qsluserheadpic'),
                page: 1,
			    pageSize: 15,
                otherVideoData:[],
                discussList:[
                    // {id:'123',name:'古拉啦huhu',content:'大家好呀~欢迎来到我们的《知识电商大咖孵化营》结 业典礼！'}
                ],
                playTime:'',
                current:'',
                playerOptions: {
                    // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: true, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        withCredentials: false,
                        type: "application/x-mpegURL", //播放类型，如果为rtmp配置为rtmp/mp4
                        src: "" //直播流地址
                    }],
                    poster: "", //你的封面地址
                    width: document.documentElement.clientWidth,
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true, // 当前时间和持续时间的分隔符
                        durationDisplay: true, // 显示持续时间
                        remainingTimeDisplay: false, // 是否显示剩余时间功能
                        fullscreenToggle: true //全屏按钮
                    }
                },
                msg: ``,
                position: 'normal',
                barrageIsShow: true,
                stageHeight: 300,
                boxWidth: 375,
                throttleGap: 5000,
                placeStyle: 'normal',
                currentId: 0,
                barrageLoop: false,
                hoverLanePause: true, // 鼠标移动到上面的时候 会暂停泳道滚动
                barrageList: []
            }
        },
        mounted() {
            this.getLiveDetail();
            this.getLiveDanmus();
            this.getPeopleList();
            this.getList();
            this.getHeight();
            this.recordinout();
            this.$nextTick(() => {
                // 进入nexTick
                let box = this.$refs.discussList; // 在html中设置id为iii的div
                // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
                box.onscroll = () => {
                    // 获取距离顶部的距离
                    var scrollTop = box.scrollTop;
                    if (scrollTop !== 0 && this.oldv == 0) {
                    this.oldv = scrollTop;
                    }
                    // 获取可视区的高度
                    var windowHeight = box.clientHeight;
                    // 获取滚动条的总高度
                    var scrollHeight = box.scrollHeight;
                    // if (scrollTop + windowHeight >= scrollHeight) {
                    //     console.log("到达底部了");
                    // }
                    if (scrollTop == 0 && this.oldv !== 0) {
                        // console.log("到达头部了");
                        if( !this.isload ){
                            this.page++;
                            this.getLiveDanmus();
                        }

                    }
                };
            });
        },
        methods:{
             // 关闭窗口之前执行
            async beforeunloadHandler(e) {
                await this.funaddWatchClass(this.timeNumber);
                clearInterval(this.timer);
                // window.close()
            },
            funaddWatchClass(whTotalTime){
                var data = {
                    "whMemberid": Cookies.get('qslmemberId'),// 企业下人员ID ,
                    "whIsEnd": false,//是否结束
                    "whPartid": this.liId,//: 课程小节ID 
                    "whTaskId": this.taskId,// 任务ID 
                    "whTaskItemId": this.taskti_ID,//子任务Id 
                    "whTotalTime": whTotalTime,//观看时长 ,
                    "whSource": "PC",//接口来源 Android iOS ,
                    "whType": "2",//进入类型 1 任务进入 2 直接进入 
                    "whWatchtime": "1",//观看位置
                    "whClassType": '3',//1、课程 2、语音直播 3、视频直播 4、文档 ,
                    "whClassid": '0',//课程ID , 
                    "whCreateon":this.$conFun.getNowTime(),// '2021-12-17 22:10:22',
                    "whIsEnd": true
                }         
                addWatchClassH(data)
                .then(res => {            
                    console.log('save ok')        
                })
                .catch(err => {});
            },
            recordTime(){
                this.timeNumber++;
            },
            tipShow(){
                this.isTip = true;
            },
            tip(){
                this.isTip = false;
            },
            handleClose(done) {
                done();
            },
            // 播放回调
            onPlayerPlay(player) {
                console.log("播放啦啦啦！", player);
                this.timeNumber = 0
                this.timer = setInterval(this.recordTime,1000);
            },
            // 暂停回调
            onPlayerPause(player) {
                console.log("已经暂停喽！", player);
                this.funaddWatchClass(this.timeNumber);
                clearInterval(this.timer)
            },
             // 视频播完回调
            onPlayerEnded($event) {
                console.log("播放完喽！",$event);
            },
            //播放状态改变回调
            playerStateChanged(playerCurrentState) {
                
                // console.log('播放器当前更新状态', playerCurrentState)
            },
            //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
            playerReadied(player) {
                console.log('播放器已就位', player);
                // player.currentTime(this.current)
            },

            // 当前播放位置发生变化时触发。
            onPlayerTimeupdate(player) {
                
            },
            
            //获取课程介绍的高，控制其他课程的高度
            getHeight(){
                let infoHeight = this.$refs.classInfo.offsetHeight;
                if( infoHeight > 544 ){
                    this.exceedHeight = true;
                }
            },

            // 其他课程跳转视频播放
            toDetail(id,type,yors){
                if( type == 2 ){  
                    if( yors != 2 ){   
                        this.$router.replace('/Lookback?liId='+id)
                    }else{
                        this.isTip = true  //音频回看
                    }
                    
                }else{
                    if( yors != 2 ){
                        this.$router.replace({
                            name:'Live',
                            query:{
                                liId:id
                            }
                        });
                        this.$router.go(0);
                    }else{
                        this.isTip = true  //音频直播
                    }
                    
                    
                }
                
            },

            // 获取直播列表
            getList() {
                let videoData = {
                    memberId: this.memberId,
                    coId: this.coid,
                    state: 4,
                    pageIndex: 1,
                    pageSize: 5
                };
                getLives(videoData)
                    .then(res => {
                        
                        if( res.code == 200 ){
                            // console.log(res);
                            let realNumer = res.body.result;
                            for( var i=0; i<realNumer.length; i++ ){
                                if( this.liId == realNumer[i].liId ){
                                    realNumer.splice(i,1);
                                }
                            }
                            this.otherVideoData = this.otherVideoData.concat(realNumer);
                            
                        }
                    }).catch(err => {
                        
                    });
            },

            // 记录直播进入和退出，观看者进入直播时和退出直播（包含直播结束退出）时调用该接口
            recordinout() {
                let recordinoutData = {
                    memberId: this.memberId,
                    liveid: this.liId,
                    type:this.inOut
                };
                recordinout(recordinoutData)
                    .then(res => {
                        
                    }).catch(err => {
                        
                    });
            },

            // 关闭/打开弹幕
            closeDanmu(){
                this.barrageIsShow = !this.barrageIsShow;
            },
            initWebSocket() {
                //建立连接
                //初始化weosocket
                const wsuri = 'wss://qsl-websocket.shihua.com?liveid=' + this.liId + '&uid=' + this.memberId;
                //建立连接
                this.websock = new WebSocket(wsuri);
                //连接成功
                this.websock.onopen = this.websocketonopen;
                //连接错误
                this.websock.onerror = this.websocketonerror;
                //接收信息
                this.websock.onmessage = this.websocketonmessage;
                //连接关闭
                this.websock.onclose = this.websocketclose;
            },
            reconnect() {
                //重新连接
                var that = this;
                if (that.lockReconnect) {
                    return;
                }
                that.lockReconnect = true;
                //没连接上会一直重连，设置延迟避免请求过多
                that.timeoutnum && clearTimeout(that.timeoutnum);
                that.timeoutnum = setTimeout(function() {
                    //新连接
                    if(that.$route.path == "/Live"){
                        that.initWebSocket();
                    }
                    // that.initWebSocket();
                    that.lockReconnect = false;
                }, 1000);
            },
            reset() {
                //重置心跳
                var that = this;
                //清除时间
                clearTimeout(that.timeoutObj);
                clearTimeout(that.serverTimeoutObj);
                //重启心跳
                that.start();
            },
            start() {
                //开启心跳
                var self = this;
                self.timeoutObj && clearTimeout(self.timeoutObj);
                self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
                self.timeoutObj = setTimeout(function() {
                    //这里发送一个心跳，后端收到后，返回一个心跳消息
                    if (self.websock.readyState == 1) {
                        //如果连接正常
                        self.websock.send("heartbeat");
                    } else {
                        //否则重连
                        self.reconnect();
                    }
                    self.serverTimeoutObj = setTimeout(function() {
                        //超时关闭
                        self.websock.close();
                    }, self.timeout);
                }, self.timeout);
            },
            websocketonopen(e) {
                //连接成功事件
                this.websocketsend('发送数据');
                //提示成功
                console.log("连接成功", 3);
                //开启心跳
                this.start();
            },
            websocketonerror(e) {
                //连接失败事件
                //错误
                console.log("WebSocket连接发生错误");
                //重连
                this.reconnect();
            },
            websocketclose(e) {
                //连接关闭事件
                //提示关闭
                console.log("连接已关闭");
                //重连
                this.reconnect();
            },
            websocketonmessage(event) {
                //接收服务器推送的信息
                //打印收到服务器的内容
                // console.log("收到服务器信息",event);
                let that = this;
                let data = JSON.parse(event.data) ;
                // console.log("收到服务器信息",data)
                //收到服务器信息，心跳重置
                if( data.type == 1 ){
                    if( data.statue == 0 ){
                        that.discussList.push({name:data.memberName,content:data.msg});
                        that.scrollToBottom();
                        that.barrageList.push({
                            // id: ++that.currentId,
                            avatar: data.header,
                            msg: data.memberName+':'+data.msg,
                            time: that.randomNum(3,10),
                            type: MESSAGE_TYPE.NORMAL
                        });
                    }
                    
                };
                if( data.msg == "结束直播" && data.type == 2){
                    that.funaddWatchClass(that.timeNumber);
                    clearInterval(that.timer);
                };
                if( data.msg == "单人禁言" && data.type == 3 ){
                    if( data.uid == that.memberId ){
                        that.disabled = true;
                        that.singleWords = true;
                    };
                };
                if( data.msg == "解除单人禁言" && data.type == 3 ){
                     if( data.uid == that.memberId ){
                        that.disabled = false;
                        that.singleWords = false;
                    };
                };
                if( data.msg == "全员禁言" && data.type == 3 ){
                    that.disabled = true;
                };
                if( data.msg == "解除全员禁言" && data.type == 3 ){
                    if( !that.singleWords ){
                        that.disabled = false;
                    }
                    
                }
                this.reset();
                
            },
            websocketsend(msg) {
                //向服务器发送信息
                this.websock.send(msg);
                // console.log(msg)
            },
        


            // 点击发送评论和弹幕消息
            addToList() {
                this.msg = this.msg.trim();
                if (!this.msg) {
                    this.$alert('评论不能为空', '提示', {
                        confirmButtonText: '确定'
                    });
                    return;
                }
                let data = {
                    modId: this.liId,
                    coid: this.coid,
                    memberId: this.memberId,
                    content: this.msg,
                    modType: 3,
                    parentId:"",
                };
                var that = this;
                saveCourseComments(data)
                    .then(res => {
                        // console.log(res)
                        if( res.code == 200 ){
                            that.barrageList.push({
                                id: ++this.currentId,
                                avatar: that.myHeadImg,
                                msg: that.myName+':'+that.msg,
                                time: that.randomNum(3,10),
                                type: MESSAGE_TYPE.NORMAL
                            });
                            that.discussList.push({name:that.myName,content:that.msg});
                            that.scrollToBottom();
                            that.wsData = {
                                type:1,
                                msg:that.msg,
                                header:that.myHeadImg,
                                memberName:that.myName
                            };
                            that.websocketsend(JSON.stringify(that.wsData));
                            that.msg = '';
                        };
                    })
                    .catch(err => {
                        console.log(JSON.stringify(err));
                    });
            },
            // 获取直播在线情况人员列表
            getPeopleList() {
                let data = {
                    audioId: this.liId
                };
                var that = this;
                getLiveStateList(data)
                    .then(res => {
                        that.onlineNumber = res.body.result.onlinelist;
                        that.offlineNumber = res.body.result.offlinelist;
                        that.isParticipate[0].participate = '已观看';
                        that.isParticipate[1].participate = '未观看';
                        that.totalNumber = '观看人';

                    })
                    .catch(err => {
                        console.log(JSON.stringify(err));
                    });
            },
            watchPeople(tab, event){
                // console.log(tab, event);
            },
            handleClick(tab, event) {
                // console.log(tab, event);
            },
            scrollToBottom(){
                this.$nextTick(()=>{
                    let box = this.$refs.discussList;
                    box.scrollTop = box.scrollHeight;
                })
            },
             // 移入
            mouseOver(index) {
                this.mouseOverActive = "color:#4B9AFB";
                this.isPlayBack = this.otherVideoData[index].liId;
                this.mouseOverActive = this.otherVideoData[index].liId;
            },
            // 移出
            mouseLeave() {
                this.mouseOverActive = "";
                this.isPlayBack = false;
            },
            // 获取课程详细信息（）
            getLiveDetail() {
                let data = {
                    liId: this.liId,
                    memberId: this.memberId
                };
                var that = this;
                getLiveDetail(data)
                    .then(res => {
                        // console.log(res)
                        if( res.code == 200 ){
                            that.playerOptions.poster = res.body.result.liLogo;
                            that.videoPoster = res.body.result.liLogo;
                            that.videoName = res.body.result.liName;
                            that.speakerName = res.body.result.speakerName;
                            that.videoTime = res.body.result.liStartTime;
                            that.videoDescribe = res.body.result.liDescription;
                            that.playerOptions.sources[0].src = res.body.result.hls;
                            if( res.body.result.liState != 0 ){
                                that.isNotstart = true;
                            };
                        }
                        // that.pageData = res.body.result;
                    })
                    .catch(err => {
                        console.log(JSON.stringify(err));
                    });
            },
            // 获取课程评论 
            // 页面打开获取弹幕消息并展示
            getLiveDanmus() {
                let data = {
                    modId: this.liId,
                    coid: this.coid,
                    pageIndex: this.page,
                    pageSize: this.pageSize,
                    modType: 3
                };
                var that = this;
                getLiveDanmus(data)
                    .then(res => {
                        // console.log(res)
                        if( res.code == 200 ){
                            let dmData = res.body.result.remarkList;
                            for(var i = 0; i < dmData.length ; i++ ){
                                // that.danmuData = {
                                //     id:dmData[i].CM_ID,
                                //     avatar:dmData[i].headPic,
                                //     msg:dmData[i].meName+':'+dmData[i].content,
                                //     time:this.randomNum(3,10),
                                //     type: MESSAGE_TYPE.NORMAL
                                // };
                                that.discussData = {
                                    id:dmData[i].CM_ID,
                                    name:dmData[i].meName,
                                    content:dmData[i].content
                                }
                                // that.barrageList.push(that.danmuData);
                                that.discussList.unshift(that.discussData)

                            };
                             if( dmData.length != 15 ){
                                this.isload = true;
                            }
                        }
                        
                    })
                    .catch(err => {
                        console.log(JSON.stringify(err));
                    });
            },
            // 生成指定随机数，作用于每条弹幕的速度
            randomNum(minNum,maxNum){
                switch(arguments.length){
                case 1:
                    return parseInt(Math.random()*minNum+1,10);
                    break;
                case 2:
                    return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10);
                    break;
                default:
                    return 0;
                    break;
                }
            }
        },
        created(){
            this.liId = this.$route.query.liId;
            this.taskId = this.$route.query.taskId;
            this.taskti_ID = this.$route.query.taskTI_ID;
            if( this.taskId == undefined ){
                this.taskId = 0;
            }
            if( this.taskti_ID == undefined ){
                this.taskti_ID = 0;
            }
            if(this.$route.path == "/Live"){
                this.initWebSocket();
            }
            
            
        },
        updated(){
            this.scrollToBottom();
        },
        beforeDestroy(){
            
        },
        destroyed(){
            this.inOut = 2;
            this.recordinout();
            this.funaddWatchClass(this.timeNumber);
            clearInterval(this.timer)
            // 销毁监听
            this.websocketclose();

        },
    }
</script>
<style scoped>
    .topm{
        margin-top: 24px;
    }
    .stage {
        width: 100%;
        height: 250px;
        margin: 0;
        position: absolute;
        left: 0;
        top: 0;
        /* background: pink; */
    }
    .playerWrap{
        position:relative;
        width: 884px;
    }
    .notStart{
        width: 884px;
    }
    .notStart img{
        display: block;
        width: 100%;
    }
    
    .discussWrap{
        width: 292px;
        height: 497px;
        background:#fff;
        border-radius: 8px;
        position: relative;
        overflow: hidden;
    }
    .discussTab{
        width: 100%;
    }
    .discussTab /deep/ .el-tabs__item{
        padding: 0;
        height: 66px;
        line-height: 66px;
        font-size: 18px;
    }
    .headerImgWrap{
        padding: 0 10px;
        
    }
    .headerImgWrap /deep/ .el-tabs__item{
        padding: 0;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }
    .discussTab /deep/ .el-tabs__active-bar{
        height: 8px;
        width: 24px!important;
        border-radius: 4px;
        left: 20%;
    }
    .headerImgWrap /deep/ .el-tabs__active-bar{
        height: 2px;
        width: 24px!important;
        border-radius: 4px;
        left: 20%;
    }
    .discussTab /deep/ .el-tabs__nav-wrap::after {
        background-color: #fff;
        
    }
    .discussTab /deep/ .el-tabs__nav-wrap{
        box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.15); 
    }
    .headerImgWrap /deep/ .el-tabs__nav-wrap{
        box-shadow: none; 
    }
    .discussText{
        height: 372px;
        /* background: pink; */
    }
    .discussBox{
        height: 44px;
        background: #fff;
        box-shadow: 0px -1px 10px 0px rgba(0,0,0,0.10); 
    }
    .discussBox input{
        height: 28px;
        width: 165px;
        background: #f0f0f0;
        border-radius: 2px;
        border:none;
        margin-left: 23px;
        margin-top: 8px;
        padding-left: 16px;
        margin-right: 24px;
        outline: none;
    }
    .discussBox button{
        display: inline-block;
        width: 56px;
        height: 28px;
        background: #4B9AFB;
        border-radius: 2px;
        color: #fff;
        border:none;
        outline: none;
        margin-top: 8px;
    }
    .discussList{
        height: 100%;
        margin: 0;
        padding: 0 24px;
        overflow: auto;
    }
    .discussItem{
        margin-bottom: 12px;
    }
    .discussItem span{
        display: inline-block;
        width: 40px;
        height: 20px;
        background: #4B9AFB;
        border-radius: 2px;
        text-align: center;
        line-height: 20px;
        color: #fff;
        font-size: 12px;
    }
    .discussItem em{
        font-style: normal;
        color:#999999;
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        font-weight: Normal;
        text-align: left;
        color: #999999;
        line-height: 18px;
        letter-spacing: 1px;
    }
    .discussItem strong{
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        font-weight: Normal;
        text-align: left;
        color: #333333;
        line-height: 18px;
    }
    .headImgList{
        margin: 0;
        padding: 0;
        outline-style: none;
        width: 100%;
        display: flex; 
        justify-content:space-between; 
        flex-wrap: wrap;
        padding: 0 6px;
        max-height: 370px;
        overflow:overlay;
    }
    .headImgItem{
        flex: 0 0 24%; 
        text-align:center;
        /* 边距懒得算，css函数代替 */ 
        margin-right: calc(4% / 3); 
        margin-bottom: calc(4% / 3);
    }
    .headImgItem:nth-child(4n){ 
        margin-right: 0; 
    }
    .headImgItem:last-child{ 
        margin-right: auto; 
    } 
    .headImgItem img{
        display: inline-block;
        width: 45px;
        height: 45px;
        border-radius: 50%;
    }
    .headImgItem span{
        width: 60px;
        display: inline-block;
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        font-weight: Normal;
        text-align: center;
        color: #999999;
        line-height: 18px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .videoContent{
        background-color: #fff;
    }
    .videoBox{
        width: 884px;
    }
    .videoInfo{
        width: 884px;
        height: 100px;
        background-color: #fff;

    }
    .videoImg{
        width: 95px;
        height: 50px;
        margin-top: 25px;
        margin-left: 24px;
        margin-right: 24px;
    }
    .videoImg img{
        width: 100%;
        height: 100%;
        border-radius: 2px;
    }
    .videoTeacher h3{
        font-size: 18px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        font-weight: Normal;
        text-align: left;
        color: #333333;
        margin: 22px 0 10px 0;

    }
    .videoTeacher h2{
        margin: 0;
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        font-weight: Normal;
        text-align: left;
        color: #999999;
    }
    .videoTeacher h2 span{
        margin-right: 15px;
    }
    .videoIntroduce{
        
        background: #ffffff;
        margin-top: 24px;
        border-radius: 5px 5px 0 0;
        overflow: hidden;
    }
    .videoDetail{
        padding-left: 40px;
        width: 884px;
        height: 66px;
        line-height: 66px;
        background: #ffffff;
        box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.10); 
        border-radius: 5px 5px 0 0;
        margin-bottom: 22px;
    }
    .videoTextImg{
        width: 884px;
        background-color: #fff;
        padding:0 24px;
    }
    /* .videoTextImg p{
        font-size: 18px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        font-weight: Normal;
        text-align: left;
        color: #333333;
        line-height: 23px;
        padding:0 25px;
        margin: 0;
        margin-bottom: 23px;
    }
    .videoTextImg p img{
        display: block;
        width: 100%;
    } */
    .otherVideo{
        width: 292px;
        
    }
    .otherVideo h3{
        height: 66px;
        line-height: 66px;
        background: #fff;
        border-radius: 8px 8px 0px 0px;
        box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.10);
        margin-top: 24px;
        margin-bottom: 0;
        position: relative;
        padding-left: 25px;
        font-size: 18px;
        color: #666;
        font-weight: normal;
    }
    .otherVideosList{
        margin: 0;
        padding: 0 24px 5px;
        outline-style: none;
        background-color: #fff;
        padding-top: 24px;
        height: 544px;
        overflow: auto;
    }
    .otherVideoItem{
        width: 100%;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.10);
        overflow: hidden; 
        margin-bottom: 24px;
    }
    .playBack{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
    .postImg{
        width: 100%;
        height: 130px;
        position: relative;
        overflow: hidden;
    }
    .pImg{
        width: 100%;
        /* vertical-align: top; */
    }
    .otherVideoTitle{
        margin: 0;
        padding: 14px 22px 18px;
        font-size: 18px;
        color: #333;
        line-height: 24px;
    }
    .otherVideoItem:hover{
        cursor: pointer;
    }
    .videoMask{
        width: 100%;
        height: 130px;
        position: absolute;
        left: 0;
        top: 0;
        background: #000;
        opacity: 0.6;
    }
    .playBackIcon{
        display: inline-block;
        width: 24px;
        height: 24px;
        margin-top: 5px;
    }
    .playBackText{
        width: 100%;
        text-align: center;
        position: absolute;
        left: 0;
        top: 53px;
    }
    .playBackText span{
        display: inline-block;
        color: #fff;
        vertical-align: top;
    }
    .mouseOverClass{
        color: #4B9AFB;
    }
    .mHeight{
        height: 1240px;

    }
    .danmuImg{
        float: right;
        width: 50px;
        height: 30px;
        line-height: 30px;
        color: #fff;
        cursor: pointer;
        text-align: center;
        background: #409EFF;
        margin-top: 35px;
        margin-right: 24px;
        border-radius: 20px;
        font-size: 14px;
    }
    .closeStyle{
        color: #999;
        float: right;
        width: 50px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        text-align: center;
        border: 1px solid #999;
        margin-top: 35px;
        margin-right: 24px;
        border-radius: 20px;
        font-size: 14px;
    }
    .w-color{
        color: #fff;
    }
    
    .audioImg{
        width: 100%;
    }
    >>>.el-dialog__header{
        padding: 0;
    }
    >>> .el-dialog__body{
        padding: 0;
    }
    >>>.el-dialog{
        background: none;
        -weblit-box-shadow:none;
        box-shadow:none;
    }
    .vjs-poster{
        width: 100%;
        height: 100%;
        background-size: cover;
    }
</style>



// WEBPACK FOOTER //
// src/views/Live/Live.vue